"use strict";

import {IQService, IRootScopeService} from "angular";
import {CacheService} from "./CacheService";
import {Subscription, from } from "rxjs";
import {forEach} from "lodash";
import {flatMap, catchError, map} from "rxjs/operators";

export class CacheProxy {

    constructor(
        protected $q:IQService,
        protected $rootScope:IRootScopeService,
        protected CacheService:CacheService
    ) {

    }

    /**
     * @param callback
     * @returns {function(any): undefined}
     */
    protected applyCallback(callback: Function) {
        return (parameter) => {
            this.$rootScope.$apply(() => {
                callback(parameter);
            });
        };
    }

    /**
     *
     * @param cacheKeys
     * @param beforeCallback
     * @param subscribeCallback
     * @returns {Subscription}
     */
    protected getObservableFromKeys(cacheKeys: string[], beforeCallback: Function, subscribeCallback: Function): Subscription {
        //noinspection TypeScriptUnresolvedFunction
        return from(cacheKeys).pipe(
                flatMap((key) => {
                    this.CacheService.getItem(key)
                        .then((item: any) => {
                            return beforeCallback(item);
                        })
                        .then(this.applyCallback(subscribeCallback))
                        .catch(x => x);

                    return this.CacheService.getObservable(key);
                }),
                catchError(x => []),
                map((item: any) => {
                    return beforeCallback(item);
                })
            ).subscribe(this.applyCallback(subscribeCallback));
    }

    /**
     * @param items
     * @param cacheKeyCallback
     * @returns {Promise<any[]>}
     */
    protected getUncachedItems(items, cacheKeyCallback: Function) {
        let promises = [];
        let uncachedItems = [];

        forEach(items, (item: string) => {
            let cacheKey = cacheKeyCallback(item);
            let promise = this.CacheService.getItem(cacheKey)
                .catch(() => {
                    return uncachedItems.push(item);
                });

            promises.push(promise);
        });

        return this.$q.all(promises).then(() => {
            return uncachedItems;
        });
    }
}